import axios from 'axios'
import { decode } from 'jsog/lib/JSOG'

const toData = response => decode(response.data)

export function getMostRecentCompletedScan(unitId): Promise {
  return axios.get(`/bw/scan/recent/${unitId}`).then(toData)
}

export function getScanById(scanId): Promise {
  return axios.get(`/bw/scan/${scanId}`).then(toData)
}

export function getScans(): Promise {
  return axios.get(`/bw/scan/`).then(toData)
}

export function deleteScan(id): Promise {
  return axios.delete(`bw/scan/${id}`)
}

export function startScan(data): Promise {
  return axios.post('/bw/scan', data)
}

export function completeScan(scanId): Promise {
  return axios.post(`/bw/scan/complete/${scanId}`)
}

export function sendemail(scanId): Promise {
  return axios.post(`/bw/scan/sendmail/${scanId}`)
}

export function exportScans(): Promise {
  return axios.get('bw/scan/export', {
    headers: {
      Accept:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    },
    responseType: 'arraybuffer'
  })
}

export function calculateScan(scanId): Promise {
  return axios.post(`/bw/scan/calculate/${scanId}`).then(toData)
}

export function enableScanExtraQuestions(scanId): Promise {
  return axios.post(`/bw/scan/extraquestions/${scanId}`)
}

export function disableScanExtraQuestions(scanId): Promise {
  return axios.delete(`/bw/scan/extraquestions/${scanId}`)
}



// WEBPACK FOOTER //
// ./src/services/scan-service.js